import emailConfig from '@/modules/base/components/email-modal/config'
import EmailModel from '@/modules/base/components/email-modal/email-model'
import lang from '@/lang'

import { toast } from '@/modules/base/components/toast/toastConfig'
import request from '@/modules/base/util/request'

const ACTION_PREFIX = 'email/details'
const SET_RELATED_EMAILS = `${ACTION_PREFIX}/setRelatedEmails`
const SET_RELATED_ATTACHMENTS = `${ACTION_PREFIX}/setRelatedAttachments`
const SET_CURRENT_EMAIL = `${ACTION_PREFIX}/setCurrentEmail`

const initialState = {
  relatedEmails: [],
  relatedAttachments: [],
  currentEmail: new EmailModel(),
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_RELATED_EMAILS:
      const { relatedEmails } = action
      return Object.assign({}, state, {
        relatedEmails,
      })

    case SET_RELATED_ATTACHMENTS:
      const { relatedAttachments } = action
      return Object.assign({}, state, {
        relatedAttachments,
      })

    case SET_CURRENT_EMAIL:
      const { currentEmail } = action
      return Object.assign({}, state, {
        currentEmail,
      })

    default:
      return state
  }
}

const setRelatedEmails = (relatedEmails) => {
  return {
    type: SET_RELATED_EMAILS,
    relatedEmails,
  }
}
const setRelatedAttachments = (relatedAttachments) => {
  return {
    type: SET_RELATED_ATTACHMENTS,
    relatedAttachments,
  }
}

const setCurrentEmail = (currentEmail) => {
  return {
    type: SET_CURRENT_EMAIL,
    currentEmail,
  }
}

export const fetchRelatedAttachments = (emailId) => {
  return (dispatch) => {
    request(`${emailConfig.baseUrl}attachments/${emailId}`, { auth: true, isConcurrent: true })
      .then(({ body: { data } }) => {
        dispatch(setRelatedAttachments(data))

      })
      .catch(() => toast.showToast({ type: 'error', message: lang.defaultErrorMessage }))
  }
}

const fetchRelatedEmails = (emailId) => {
  return (dispatch) => {
    request(`${emailConfig.baseUrl}related/${emailId}`, { auth: true, isConcurrent: true })
      .then(({ body: { data } }) => {
        const relatedEmails = data.map((email) => new EmailModel(email))
        dispatch(setRelatedEmails(relatedEmails))
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.defaultErrorMessage }))
  }
}

export const fetchImapEmailDetails = (emailId) => {
  return (dispatch) => {
    request(`${emailConfig.baseUrl}customer/${emailId}`, { auth: true, isConcurrent: true })
      .then(({ body: { data } }) => {
        data.isAttachmentIncluded && dispatch(fetchRelatedAttachments(emailId))
        dispatch(fetchRelatedEmails(emailId))
        dispatch(setCurrentEmail(new EmailModel(data)))
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.defaultErrorMessage }))
  }
}
